// ContactSection.jsx
import React, { useState } from "react"
import "./MapSelect.css"

export default function MapSelect() {
  const [selectedLocation, setSelectedLocation] = useState("etruria")

  const locations = {
    etruria: {
      address: "Av. Agustín Quaranta 1180, X2681 Etruria, Córdoba",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3376.0394611953!2d-63.25699492378369!3d-32.17242997490244!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95cd0a9b8a3a3c3d%3A0x2c3a8d5b6c594f3f!2sAv.%20Agust%C3%ADn%20Quaranta%201180%2C%20X2681%20Etruria%2C%20C%C3%B3rdoba!5e0!3m2!1ses!2sar!4v1716380000000!5m2!1ses!2sar",
    },
    laCarlota: {
      address: "San Martin 970, X2670 La Carlota, Córdoba",
      mapUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3352.9526587367!2d-63.30462492376613!3d-32.83025598259982!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95d0e7c3c2c1b8a7%3A0x8f6a0f9e5b546f9e!2sSan%20Mart%C3%ADn%20970%2C%20La%20Carlota%2C%20C%C3%B3rdoba!5e0!3m2!1ses!2sar!4v1716380000000!5m2!1ses!2sar",
    },
  }

  return (
          <div className="form-section">
            <div className="card" style={{ maxWidth: "100%" }}>
              <div className="card-header">
                <span className="label">Sucursal:</span>
                <select
                  value={selectedLocation}
                  onChange={(e) => setSelectedLocation(e.target.value)}
                >
                  <option value="etruria">Etruria</option>
                  <option value="laCarlota">La Carlota</option>
                </select>
              </div>

              <div className="card-body">
                <p className="address-label">Dirección:</p>
                <p className="address-value">{locations[selectedLocation].address}</p>
              </div>

              <div className="map-container">
                <iframe
                  src={locations[selectedLocation].mapUrl}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen={false}
                  loading="lazy"
                  title="Mapa de ubicación"
                ></iframe>
              </div>
            </div>
          </div>
  )
}
